import { render, staticRenderFns } from "./ChangeMerchantSettled.vue?vue&type=template&id=25642e8e&scoped=true&"
import script from "./ChangeMerchantSettled.vue?vue&type=script&lang=js&"
export * from "./ChangeMerchantSettled.vue?vue&type=script&lang=js&"
import style0 from "./ChangeMerchantSettled.vue?vue&type=style&index=0&id=25642e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25642e8e",
  null
  
)

export default component.exports